import React from 'react';
import styled from '@emotion/styled';
import { BLACK } from '../../../styles/constants/color';

const Element = styled.span<{
  spanFontWeight: string;
  spanFontSize: string;
  spanLineHeight: string;
  spanColor: string;
  spanLetterSpacing: string;
}>`
  width: auto;
  height: auto;
  font-size: ${props => props.spanFontSize};
  font-weight: ${props => props.spanFontWeight};
  color: ${props => props.spanColor};
  line-height: ${props => props.spanLineHeight};
  letter-spacing: ${props => props.spanLetterSpacing};
`;

interface Props {
  fontWeight?: string;
  fontSize?: string;
  lineHeight?: string;
  color?: string;
  letterSpacing?: string;
  children: React.ReactNode;
}

/**
 *  자주 사용되는 span 태그 컴포넌트
 * @param {string} fontWeight  폰트 굵기 (default '400')
 * @param {string} fontSize  폰트 크기 (default: '13px')
 * @param {string} lineHeight  언더라인 기준으로부터의 높이 (default: '1')
 * @param {string} color  폰트 색상 (deafult: #222)
 * @param {string} children span 태그안에 들어갈 자식 컴포넌트
 * @param {string} letterSpacing  폰트 간격 (deafult: 'normal')
 *  */
function Span({
  fontWeight = '400',
  fontSize = '13px',
  lineHeight = '1',
  color = BLACK,
  letterSpacing = 'normal',
  children,
}: Props): JSX.Element {
  return (
    <Element
      spanFontWeight={fontWeight}
      spanFontSize={fontSize}
      spanLineHeight={lineHeight}
      spanColor={color}
      spanLetterSpacing={letterSpacing}
    >
      {children}
    </Element>
  );
}

export default Span;
